<div class="picker-numeric">
  <div class="row">
    <span class="prefix">$</span>
    <input
      type="text"
      class="num"
      inputmode="numeric"
      [value]="displayValue()"
      (input)="onInput($any($event.target))"
      placeholder="0"
      maxlength="13"
      aria-label="Premium amount"
    />
  </div>
</div>
